module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_5010.01d92e43.png";